<!--
   Usage
  1. <breadcrumb
    :list="breadcrumbList"/>
  2. list is a array of object keys are 'name', 'url'
        {
            name:'Name of the breadcrumb',
            url:'url which needs to be redirect' // ex: /dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/payrollreport
        }
-->

<template>
    <div>
        <ul class="breadcrumb">
            <li v-for="(data, index) in list" :key="index">
                <router-link :to="data.url">{{data.name}}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'BreadCrumb',
        props: {
            list: Array
        },
    }
</script>
